var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin"},[_c('Menu'),_c('PaymentDetails',{ref:"details"}),_c('CollapsibleBox',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Validation non capturés ")]},proxy:true},{key:"content",fn:function(){return [_c('NonCaptures')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }